import { useMemo } from 'react'
import CustomComponentSlot from '../../custom-component-slot/CustomComponentSlot'
import { useAccountPageUIContext } from '../AccountPageProvider'
import { AccountOrdersSlotPosition, AccountPageRealEstate } from '../types'

type AccountCustomComponentSlotProps = {
  /** Known page the slot lives on, matched against the component's `type` */
  page: 'ORDERS'
  position: AccountOrdersSlotPosition
}

// Renders the merchant HTML configured for this slot of a known page. Components
// sharing a page and position are joined in config order. Never renders in the
// dashboard so merchant scripts don't run in the editor.
const AccountCustomComponentSlot = ({ page, position }: AccountCustomComponentSlotProps) => {
  const { uiConfig, data, realEstate } = useAccountPageUIContext()
  const components = uiConfig?.custom_component_config?.custom_components
  const user = data?.profilePage?.user
  // The user object is rebuilt on unrelated data changes, so compare by value.
  const userKey = [user?.name, user?.phone, user?.primaryEmail].join('|')

  const html = useMemo(() => {
    if (realEstate === AccountPageRealEstate.DASHBOARD) return null
    const matching = (components ?? []).filter(
      component =>
        component?.enabled &&
        component?.html_text_string &&
        component?.type?.trim().toUpperCase() === page &&
        component?.position?.trim().toUpperCase() === position
    )
    return matching.length ? matching.map(component => component.html_text_string).join('') : null
  }, [components, realEstate, page, position])

  if (!html) return null
  return <CustomComponentSlot html={html} rerunDeps={[userKey]} />
}

export default AccountCustomComponentSlot
